﻿import type { RouteRecordRaw } from 'vue-router'

const projectRoutes: RouteRecordRaw = {
  path: '/project',
  name: 'Project',
  redirect: '/project/setup',
  meta: { title: '项目管理', icon: 'icon-experiment' },
  children: [
    { path: 'setup', name: 'ProjectSetup', component: () => import('@/views/project/SetupList.vue'), meta: { title: '项目立项', permissions: ['project:setup:view'] } },
    { path: 'income', name: 'ProjectIncome', component: () => import('@/views/project/IncomeList.vue'), meta: { title: '项目收支', permissions: ['project:income:view'] } },
    { path: 'cost', name: 'ProjectCost', component: () => import('@/views/project/CostList.vue'), meta: { title: '项目成本', permissions: ['project:cost:view'] } },
  ],
}

export default projectRoutes
